import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { User, UserQueryParams } from '@/types/user';
import { userService } from '@/services/userService';

interface UserState {
  items: User[];
  loading: boolean;
  error: string | null;
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

const initialState: UserState = {
  items: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
};

export const fetchUsers = createAsyncThunk(
  'user/fetchUsers',
  async (params: UserQueryParams) => {
    const response = await userService.getUsers(params);
    return response;
  }
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPagination: (state, action) => {
      if (state.page !== action.payload.page || state.pageSize !== action.payload.pageSize) {
        state.page = action.payload.page;
        state.pageSize = action.payload.pageSize;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.pageSize = action.payload.size;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '获取用户列表失败';
      });
  },
});

export default userSlice.reducer;
